import PropTypes from "prop-types"

import { Box, useDisclosure } from "@chakra-ui/react"
import { useBrandedTranslation } from "../../../../common/hooks/useBrandedTranslation"
import CustomTooltip from "../../../shared/CustomTooltip"
import { specialSymbols } from "../common/constants"
import { useArticlesFilter } from "../context/ArticlesFilterContext"
import HighlightedString from "./HighlightedString"

const ArticleCode = ({ articleCode, hasOrderRelated }) => {
  const { t } = useBrandedTranslation()
  /* This makes a controlled tooltip so it shows on touch on mobile */
  const { isOpen, onOpen, onToggle, onClose } = useDisclosure()
  const articlesFilter = useArticlesFilter()

  const tooltipLabel = hasOrderRelated ? t("pdp-article-produce-on-order-text") : ""
  const articleCodeText = hasOrderRelated ? `${articleCode} ${specialSymbols.ASTERISK}` : articleCode

  return (
    <CustomTooltip label={tooltipLabel} isOpen={isOpen}>
      <Box as="span" onMouseEnter={onOpen} onMouseLeave={onClose} onClick={onToggle}>
        <HighlightedString originalString={articleCodeText} highlightedString={articlesFilter} />
      </Box>
    </CustomTooltip>
  )
}

export default ArticleCode

ArticleCode.propTypes = {
  articleCode: PropTypes.string,
  hasOrderRelated: PropTypes.bool,
}
